import { createSlice } from '@reduxjs/toolkit'

export const objectSlice = createSlice({
  name: 'object',
  initialState: {
    sections: {
      Masterdata: { edit: false, disabled: false, maximized: true },
      Media:      { edit: false, disabled: false, maximized: true },
      Texts:      { edit: false, disabled: false, maximized: true },
      Transfers:  { edit: false, disabled: false, maximized: true },
      Contracts:  { edit: false, disabled: false, maximized: true },
      Exports:    { edit: false, disabled: false, maximized: true },
      Allotments: { edit: false, disabled: false, maximized: true },
      History:    { edit: false, disabled: false, maximized: true }
    },
    isEditMode : false,
    isDirty : false,
    isSidebar: false,
    objectID: false,
    contractID: false,
    data: null,
    dataOriginal: null,
    dataChanges: [],
    currentChangeNr: 0,
    meta: null,
    templates: {
      Transfer: {
        DestinationAirport: '',
        DestinationCode: '',
        BusTransfer: '',
        TaxiTransfer: '',
        TransferMail1: '',
        SubmitToStore: ''
      }
    }
  },
  reducers: {
    showObjectSidebar: (state) => { state.isSidebar = true },
    hideObjectSidebar: (state) => { state.isSidebar = false },

    maximizeSection: (state, action) => {
      state.sections[action.payload].maximized = true;
    },
    minimizeSection: (state, action) => {
      state.sections[action.payload].maximized = false;
    },
    
    setMetaData: (state, action) => { state.meta = action.payload; },
    setObjectID: (state, action) => { state.objectID = action.payload; },
    setObjectData: (state, action) => { state.data = action.payload; },

    setObjectDataOriginal: (state, action) => { 
      if (action.payload && !state.dataOriginal) {
        state.dataOriginal = action.payload;
      }
    },

    updateObjectData: (state, action) => {
      switch (action.payload.section) {
        case 'Product':
          state.data.Product[action.payload.key] = action.payload.value;
          break;

        case 'Masterdata':
          if (typeof action.payload.group !== 'undefined' && action.payload.group) {
            state.data.Basics[action.payload.group][action.payload.key] = action.payload.value;
          } else {
            state.data.Basics[action.payload.key] = action.payload.value;
          }
          break;

        case 'Address':
          state.data.Address[action.payload.key] = action.payload.value;
          break;

        case 'DistributionChannels':
          state.data.DistributionChannels[action.payload.key] = action.payload.value;
          break;

        case 'Texts':
          if (Array.isArray(state.data.DescriptionsTexts)) {
            state.data.DescriptionsTexts = {};
          }

          if (typeof state.data.DescriptionsTexts[action.payload.language] === 'undefined') {
            state.data.DescriptionsTexts[action.payload.language] = {Texts: {}}
          }
          state.data.DescriptionsTexts[action.payload.language].Texts[action.payload.key] = action.payload.value;  
          break;

        case 'Images':
          if (action.payload.subTarget) {
            state.data.Images[action.payload.key][action.payload.target][action.payload.subTarget] = action.payload.value;
          } else {
            state.data.Images[action.payload.key][action.payload.target] = action.payload.value;
          }
          break;

        case 'Transfers':
          state.data.Transfers[action.payload.index][action.payload.key] = action.payload.value;
          break;
        case 'AddTransfer':
          state.data.Transfers.push(state.templates.Transfer);
          break;

        case 'Contracts':
          state.data.Contracts = action.payload.value;
          break;

        case 'Allotments':
          state.data.Allotments = action.payload.value;
          break;

        default: break;
      }
    },

    doObjectAction: (state, action) => {
      switch (action.payload.target) {
        case 'AddTransfer': state.data.Transfers.push(state.templates.Transfer); break; 
        case 'DeleteTransfer': state.data.Transfers.push(state.templates.Transfer); break; 
        default: break;
      }
    },

    setContractID: (state, action)  => { state.contractID = action.payload; },

    setCurrentChangeNr: (state, action)  => { state.currentChangeNr = action.payload; console.log('[state.currentChangeNr]', state.currentChangeNr); },

    startEdit: (state, action) => {
      if (state.dataOriginal === null) {
        state.dataOriginal = state.data;
      }

      // switch  to edit mode
      Object.keys(state.sections).forEach(key => {
        state.sections[key].disabled = true;
      });
      state.sections[action.payload].edit = true;
      state.sections[action.payload].disabled = false;
    },

    confimEdit: (state, action) => {
      state.dataChanges.push(state.data);
      state.isDirty = true;
      state.currentChangeNr = state.dataChanges.length;

      // switch back to readonly mode
      state.sections[action.payload].edit = false;
      Object.keys(state.sections).forEach(key => {
        state.sections[key].disabled = false;
      });
    },

    abortEdit: (state, action) => {
      state.dataChanges = [];
      state.isDirty = false;
      state.currentChangeNr = 0;
      if (state.dataOriginal !== null) {
        state.data = state.dataOriginal;
      }

      // switch back to readonly mode
      if (typeof state.sections[action.payload] !== 'undefined') {
        state.sections[action.payload].edit = false;
      }
      Object.keys(state.sections).forEach(key => {
        state.sections[key].disabled = false;
      });
    },

    deleteFromChanges: (state, action)  => { 
      if (typeof action.payload && !isNaN(action.payload)) {
        state.dataChanges.slice(action.payload, 1);
      } else {
        state.data = state.dataChanges.pop();
      }
      if (!state.dataChanges.length) {
        state.isDirty = false;  
      }
    },

    deleteLastChange: (state) => { 
      state.dataChanges.pop();
      if (state.dataChanges.length) {
        state.data = state.dataChanges[state.dataChanges.length - 1];
        state.currentChangeNr = state.dataChanges.length;
      } else {
        state.data = state.dataOriginal;
        state.isDirty = false;
        state.currentChangeNr = 0;
      }
    },

    deleteAllChanges: (state) => { 
      state.data = state.dataOriginal;
      state.dataChanges = [];
      state.isDirty = false;
    },

    confimChanges: (state) => {
      state.dataChanges = [];
      state.isDirty = false;
      state.currentChangeNr = 0;
    },

    resetObject: (state) => {
      state.isDirty = false;
      state.dataChanges = [];
      state.data = state.dataOriginal;
      state.dataOriginal = null;
      state.currentChangeNr = 0;
    }
  },
})

// Action creators are generated for each case reducer function
export const { 
  maximizeSection, 
  minimizeSection,
  showObjectSidebar,
  hideObjectSidebar,
  
  setObjectID, 
  setObjectData,
  setObjectDataOriginal, 
  setMetaData, 
  setContractID, 
  
  updateObjectData, 
  doObjectAction,
  
  setCurrentChangeNr,
  deleteFromChanges,
  deleteAllChanges,
  deleteLastChange,
  confimChanges,
  startEdit,
  confimEdit,
  abortEdit,
  resetObject
} = objectSlice.actions

export default objectSlice.reducer